function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import styles from './ScreenLink.module.scss';
import { Link } from 'react-router-dom';
import cs from 'classnames';
import ListItem from '../ListItem';
export default function ScreenLink(_ref) {
  var id = _ref.id,
    item = _ref.item,
    name = _ref.name,
    orientation = _ref.orientation,
    level = _ref.level,
    href = _ref.href,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ListItem, {
    className: cs(styles.item, styles["level--".concat(level)], _defineProperty(_defineProperty({}, styles[String(orientation)], !!orientation), styles[orientation + '-' + level], !!orientation))
  }, /*#__PURE__*/React.createElement(Link, {
    to: href,
    className: cs(styles.link, "screen-list__link", "auto-main-menu-screen-link", _defineProperty({}, styles.solo, level === 0)),
    dangerouslySetInnerHTML: {
      __html: name
    }
  }), children);
}